import moment from 'moment-timezone';
import countryTimeZones from '../constants/enums/timeZones';

export function convertPropertyDateToUTCTime(dateAtProperty, propertyTimeZone) {
  const timeAtProperty = moment.tz(dateAtProperty, propertyTimeZone);

  const propertyMoment = moment.tz(timeAtProperty, propertyTimeZone);

  const convertedToUTC = propertyMoment.tz('UTC').format();

  return convertedToUTC;
}

export function convertUTCDateToPropertyTime({ dateInUTC, propertyTimeZone, fullISOFormat = false }) {
  const dbTime = moment.utc(dateInUTC);
  const convertedToPropertyTime = fullISOFormat
    ? dbTime.tz(propertyTimeZone).format()
    : dbTime.tz(propertyTimeZone).format('YYYY-MM-DD');

  return convertedToPropertyTime;
}

export const convertUTCDateToTimeZone = (dateString, country, format) => {
  const timezones = {
    CA: countryTimeZones.CanadaAtlantic,
    AU: countryTimeZones.AustraliaSydney,
    US: countryTimeZones.USEastern
  };
  // Parse the date as UTC
  const date = moment.utc(dateString);
  // Convert to chosen timezone based on currency variable
  const localDate = moment.tz(date, timezones[country]);

  // Format the date to include the correct day of the week
  return localDate.format(format);
};
